import { z } from 'zod';

export const CodeValidatorSchema = z.object({
  maxTimesUsed: z.number(),
  code: z.string(),
  timesUsed: z.number(),
});

export type CodeValidator = z.infer<typeof CodeValidatorSchema>;
